import { render, staticRenderFns } from "./GlobalButtonEdit.vue?vue&type=template&id=d4fd797e"
import script from "./GlobalButtonEdit.vue?vue&type=script&lang=js"
export * from "./GlobalButtonEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports